/* Astra v2 — interface du chat : réponses structurées, boutons de lien, suggestions de suite. */
(() => {
  function initAstra() {
    const root = document.querySelector('[data-astra]');
    if (!root) return;
    const toggle = root.querySelector('[data-astra-toggle]');
    const panel = root.querySelector('[data-astra-panel]');
    const messages = root.querySelector('[data-astra-messages]');
    const chips = root.querySelector('[data-astra-chips]');
    const form = root.querySelector('[data-astra-form]');
    const input = root.querySelector('[data-astra-input]');
    const openIcon = root.querySelector('.astra__icon-open');
    const closeIcon = root.querySelector('.astra__icon-close');
    const errorMsg = root.dataset.error || 'Je reviens vers vous dans un instant. En attendant, écrivez-nous à contact@celestiar.fr.';
    let busy = false;
    const claudeUrl = String(root.dataset.claudeUrl || '').trim().replace(/\/$/, '');
    const history = [];

    messages.setAttribute('aria-live', 'polite');
    const scroll = () => { messages.scrollTop = messages.scrollHeight; };
    const setOpen = (open) => {
      panel.hidden = !open;
      openIcon.hidden = open;
      closeIcon.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) window.setTimeout(() => input.focus(), 80);
    };
    toggle.addEventListener('click', () => setOpen(panel.hidden));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !panel.hidden) setOpen(false); });

    /* **gras** → <strong>, sans jamais injecter de HTML */
    const inline = (parent, text) => {
      text.split('**').forEach((part, i) => {
        if (!part) return;
        if (i % 2) { const s = document.createElement('strong'); s.textContent = part; parent.appendChild(s); }
        else parent.appendChild(document.createTextNode(part));
      });
    };
    /* paragraphes et listes à puces */
    const format = (node, text) => {
      node.textContent = '';
      let list = null;
      text.split('\n').forEach((line) => {
        if (line.startsWith('• ')) {
          if (!list) { list = document.createElement('ul'); node.appendChild(list); }
          const li = document.createElement('li'); inline(li, line.slice(2)); list.appendChild(li);
        } else {
          list = null;
          if (!line.trim()) return;
          const p = document.createElement('p'); inline(p, line); node.appendChild(p);
        }
      });
    };

    const addUser = (text) => {
      const node = document.createElement('div');
      node.className = 'astra__message astra__message--user';
      node.textContent = text;
      messages.appendChild(node);
      scroll();
    };
    const addTyping = () => {
      const node = document.createElement('div');
      node.className = 'astra__message astra__message--assistant astra__typing';
      node.setAttribute('aria-label', '…');
      node.innerHTML = '<span></span><span></span><span></span>';
      messages.appendChild(node);
      scroll();
      return node;
    };
    const addAnswer = (res) => {
      const wrap = document.createElement('div');
      wrap.className = 'astra__turn';
      const bubble = document.createElement('div');
      bubble.className = 'astra__message astra__message--assistant astra__rich';
      format(bubble, res.text);
      wrap.appendChild(bubble);
      if (res.links && res.links.length) {
        const row = document.createElement('div'); row.className = 'astra__links';
        res.links.forEach((l) => { const a = document.createElement('a'); a.href = l.href; a.textContent = l.label; row.appendChild(a); });
        wrap.appendChild(row);
      }
      if (res.chips && res.chips.length) {
        const row = document.createElement('div'); row.className = 'astra__suggest';
        res.chips.slice(0, 4).forEach((c) => {
          const b = document.createElement('button'); b.type = 'button'; b.textContent = c;
          b.addEventListener('click', () => { row.remove(); send(c); });
          row.appendChild(b);
        });
        wrap.appendChild(row);
      }
      messages.appendChild(wrap);
      scroll();
    };

    const send = (text) => {
      const message = String(text || input.value || '').trim();
      if (!message || busy) return;
      busy = true;
      input.value = '';
      if (chips) chips.hidden = true;
      messages.querySelectorAll('.astra__suggest').forEach((n) => n.remove());
      addUser(message);
      const typing = addTyping();
      const lc = window.CelestiarAstraLocal;
      let res;
      try { res = lc.answer(message); } catch (e) { res = { text: errorMsg, links: [], chips: [] }; }
      const finish = (r) => {
        typing.remove();
        addAnswer(r);
        history.push({ role: 'user', text: message }, { role: 'assistant', text: r.text });
        busy = false;
        input.focus();
      };
      /* question inconnue de la base : Claude répond (si le relais est branché), sinon réponse locale */
      if ((res.id === 'fallback' || res.score <= 2) && claudeUrl) {
        const controller = new AbortController();
        const timer = window.setTimeout(() => controller.abort(), 20000);
        fetch(claudeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ message, history: history.slice(-6), context: lc.context(lc.isEn(message)), lang: lc.isEn(message) ? 'en' : 'fr' }),
          signal: controller.signal
        })
          .then((r) => (r.ok ? r.json() : Promise.reject(new Error('http'))))
          .then((data) => {
            const text = String((data && data.reply) || '').replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}]/gu, '').trim();
            if (!text) throw new Error('empty');
            finish({ text, links: [{ label: lc.isEn(message) ? 'Write to the team' : "Écrire à l'équipe", href: 'mailto:contact@celestiar.fr' }], chips: [] });
          })
          .catch(() => finish(res))
          .finally(() => window.clearTimeout(timer));
        return;
      }
      const delay = Math.min(850, 320 + res.text.length * 1.2);
      window.setTimeout(() => finish(res), delay);
    };

    form.addEventListener('submit', (e) => { e.preventDefault(); send(); });
    root.querySelectorAll('[data-astra-chip]').forEach((chip) => chip.addEventListener('click', () => send(chip.textContent)));
  }
  document.addEventListener('DOMContentLoaded', initAstra);
})();
